import _filter from 'lodash/filter';
export var FILTER_GROUP_CHANGE = 'FILTER_GROUP_CHANGE';
export var FILTER_GROUP_UPDATE = 'FILTER_GROUP_UPDATE';
export var RENAME_FILTER_GROUP = 'RENAME_FILTER_GROUP';
export var DELETE_FILTER_GROUP = 'DELETE_FILTER_GROUP';
export var SAVE_AS_NEW_FILTER_GROUP = 'SAVE_AS_NEW_FILTER_GROUP';
var renameAction = function renameAction(nonRenamable) {
  return {
    id: RENAME_FILTER_GROUP,
    name: __('Rename'),
    isEnabled: !nonRenamable
  };
};
var deleteAction = function deleteAction(nonDeletable) {
  return {
    id: DELETE_FILTER_GROUP,
    name: __('Delete'),
    isEnabled: !nonDeletable
  };
};
var saveAsNewAction = function saveAsNewAction(isModified) {
  return {
    id: SAVE_AS_NEW_FILTER_GROUP,
    name: __('Save as New'),
    isEnabled: isModified
  };
};
export var getActions = function getActions(isModified, nonRenamable, nonDeletable) {
  var actions = [renameAction(nonRenamable), deleteAction(nonDeletable), saveAsNewAction(isModified)];
  return _filter(actions, function (action) {
    return action.isEnabled;
  });
};